import type { ReactNode } from 'react';
import { ToolbarActions } from './ToolbarActions';
import { cn } from '@simplywallst/ui-core/next';

type Props = {
  children?: ReactNode;
  className?: string;
};

const toolbarStickyClasses = cn([
  'grid',
  'grid-cols-[auto_max-content]',
  'justify-between',
  'gap-x1',
  'py-x1',
  'bg-surface-1',
  'border-solid',
  'border-0',
  'border-t',
  'border-t-p-white-100/20',
  'sticky',
  'bottom-0',
  'z-20',
]);

export const ToolbarSticky = ({ children, className }: Props) => {
  return (
    <section className={cn(toolbarStickyClasses, className)}>
      <ToolbarActions />
      {children}
    </section>
  );
};
